var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"billing-date"},[_c('div',{staticClass:"previous-billing-date"},[_vm._v(_vm._s(_vm.previousBillingDate))]),_vm._v(" "),_c('div',{staticClass:"new-billing-date"},[_vm._v(_vm._s(_vm.currentBillingDate))])])}
var staticRenderFns = []

export { render, staticRenderFns }